import { initialState } from "@reducers/organisationDirectoryReducer";

export const emptySettingsSection =
  (clearFilters = true) =>
  async (dispatch) => {
    if (clearFilters)
      dispatch({
        type: "FETCH_SETTINGS_FILTERS",
        payload: { ...initialState },
      });
  };
